import { useEffect, useState } from "react";
import { AddOtherMainSubSectors } from "../../../../Services/OtherMainSubSectors";
import InputAHSF from "../../../../Components/InputAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import $ from "jquery";

import "./style.css";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import {
  GetAllActiveAI_MainSector,
  GetAllAI_SubSector,
} from "../../../../Redux/Reducers/DropDownApplicationInformation";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import {
  GetSecondarySectors,
  restSecondarySectorsValidate,
  ValidateAI_SecondarySectors,
} from "../../../../Redux/Reducers/SecondarySectors";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import { UpdateOtherMainSectors } from "../../../../Services/OtherMainSubSectors/UpdateOtherMainSectors";
import Swal from "sweetalert2";
import { GetListSecondarySectors } from "../../../../Redux/Reducers/ApplicationInformation";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Account/EncryptionParams";

const AddEditeSubSectorsPage = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();

  const state = useSelector((state) => {
    return {
      // dropDownApplicationInformation:
      //   state.dropDownApplicationInformation.SubSector,
        dropDownApplicationInformation:
        state.dropDownApplicationInformation.AllActiveAI_MainSector,
      dropDownApplicationInformationLoding:
        state.dropDownApplicationInformation,
      SubSectors: state.SubSectors,
      aI_SecondarySectorsValidate: state.SubSectors.aI_SecondarySectorsValidate,
      loadingaI_SecondarySectorsValidate:
        state.SubSectors.loadingaI_SecondarySectorsValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      ListSecondarySectors: state.ApplicationInformation.ListSecondarySectors,
      AI_MainSector: state.dropDownApplicationInformation.AI_MainSector,
    };
  });
  //console.log(state.ListSecondarySectors, "SecondarySectorsList");
  const loadingaI_SecondarySectorsValidate = useSelector(
    (state) => state.SubSectors.loadingaI_SecondarySectorsValidate
  );
  const [SubSectors, setSubSectors] = useState({
    aI_SubSectorId: null,
    aI_MainSectorId: null,
    aI_ApplicationInformationId: localStorage.getItem(
      "aI_ApplicationInformationId"
    ),
  });

  // Function to validate the secondary sector based on the passed ID.
  const ValidateFunction = (aI_MainSectorId) => {
    // Dispatch an action to validate the secondary sector by its ID.
    dispatch(ValidateAI_SecondarySectors(aI_MainSectorId));
  };

  useEffect(() => {
    // This effect runs once when the component mounts.
    // Dispatch an action to reset the validation state of secondary sectors.
    dispatch(restSecondarySectorsValidate());
  }, []);
  // Dependency array: Empty, meaning this effect runs only once after the initial render.

  useEffect(() => {
    // This effect also runs once when the component mounts.
    // Fetch a list of secondary sectors by making an API call, using either
    // a stored value (`aI_ApplicationInformationId`) from localStorage or a decrypted AppGuid.
    dispatch(
      GetListSecondarySectors(
        localStorage.getItem("aI_ApplicationInformationId") || // Try getting the ID from localStorage.
          decryptToken(AppGuid.AppGuid) // If not found, decrypt `AppGuid.AppGuid` for the required value.
      )
    );
  }, []);
  // Dependency array: Empty, meaning this effect runs only once after the initial render.

  // dispatch(setRefreshTable());

  // Function to add a new sub-sector to the system.
  const addSubSectorsPage = async () => {
    // Validate the sub-sector by its ID.
    ValidateFunction(SubSectors.aI_MainSectorId);

    // Check if the sub-sector already exists in the list of secondary sectors.
    const isDuplicate = state.ListSecondarySectors.some(
      (sector) => sector.aI_MainSectorId == SubSectors.aI_MainSectorId
    );

    // If the sub-sector already exists, show an error popup and exit the function.
    if (isDuplicate) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "لا يمكنك اختيار هذا القطاع مرة اخرى", // "You cannot select this sector again"
        showConfirmButton: false,
        timer: 1500, // Display the error for 1.5 seconds.
      });
      return;
    }

    // If the sub-sector ID is not null, proceed to add it.
    if (SubSectors.aI_MainSectorId != null) {
      // Call the API to add the sub-sector.
      const add = await AddOtherMainSubSectors(SubSectors);
      if (add) {
        // If added successfully, close the modal and show a success message.
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم اضافة المعلومات بنجاح", // "Information added successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });
        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    }
  };

  // Function to update an existing sub-sector.
  const updateSubSectorPage = async () => {
    // Check if the sub-sector already exists in the list.
    const isDuplicate = state.ListSecondarySectors.some(
      (sector) => sector.aI_MainSectorId == SubSectors.aI_MainSectorId
    );

    // If the sub-sector already exists, show an error popup and exit the function.
    if (isDuplicate) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "لا يمكنك اختيار هذا القطاع مرة اخرى", // "You cannot select this sector again"
        showConfirmButton: false,
        timer: 1500, // Display the error for 1.5 seconds.
      });
      return;
    }

    // Call the API to update the sub-sector using its ID and new data.
    const update = await UpdateOtherMainSectors(
      props.SecondarySectorsId,
      SubSectors
    );
    if (update) {
      // If updated successfully, close the modal and show a success message.
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح", // "Information updated successfully"
        showConfirmButton: false,
        timer: 1500, // Display success message for 1.5 seconds.
      });

      // Refresh the table by dispatching the action to update the table data.
      dispatch(setRefreshTable());
    }
  };

  useEffect(() => {
    // This effect runs once when the component mounts.
    // Dispatch an action to get all sub-sectors for a given main sector ID from the state.
    // dispatch(GetAllAI_SubSector(state.ApplicationInformation.aI_MainSectorId));
    dispatch(GetAllActiveAI_MainSector());
  }, []);
  // Dependency array: Empty, meaning this effect runs only once after the initial render.

  useEffect(() => {
    // This effect runs when `props.SecondarySectorsId` changes.
    if (props != null) {
      // If `props` is not null, dispatch an action to get the secondary sectors using the provided ID.
      dispatch(GetSecondarySectors(props.SecondarySectorsId));
    }
  }, [props.SecondarySectorsId]);
  // Dependency array: Runs when `props.SecondarySectorsId` changes.

  useEffect(() => {
    // This effect runs when `state.SubSectors` changes.
    if (
      !state.SubSectors.loadingaI_SecondarySectors && // Check if the secondary sectors data is not loading.
      Object.keys(props).length != 0 // Check if `props` is not an empty object.
    ) {
      // If data is loaded and props are valid, update the state of sub-sectors.
      setSubSectors({
        ...SubSectors, // Keep the current state of `SubSectors`.
        aI_MainSectorId: state.SubSectors?.aI_SecondarySectors?.aI_MainSectorId, // Set the `aI_SubSectorId` from the fetched data.
      });
    }
  }, [state.SubSectors]);
  // Dependency array: Runs when `state.SubSectors` changes.

  // //console.log(state.SubSectors&&state.SubSectors.aI_SecondarySectors.aI_SubSectorId,"malkekhhjhjh");
  const shouldDisableFields = !(
    //[,]
    // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
    (
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    )
  );

  return (
    <div className="AddEditeSubSectorsPage">
      <AllDropDownsAHSF
        fieldsName="SubSectors"
        show={true}
        disabled={shouldDisableFields}
        // showValidationMessage={SubSectors.aI_SubSectorId==null?true:false}
        // validationMessage="يرجى تعبئة هذا الحقل"
        value={SubSectors.aI_MainSectorId}
        onChange={(e) => {
          setSubSectors({
            ...SubSectors,
            aI_MainSectorId: e.target.value,
          });
        }}
        // arrayOoptionList={state.dropDownApplicationInformation}
        arrayOoptionList={state.AI_MainSector}
        KeyText={"mainSectorAr"}
        KeyValue={"aI_MainSectorId"}
        dropdownType={"normal"}
        showValidationMessage={
          state.aI_SecondarySectorsValidate
            ? state.aI_SecondarySectorsValidate.includes("SubSectors")
            : false
        }
        validationMessage="يرجى تعبئة هذا الحقل"
      />

      {!shouldDisableFields ? (
        <div className="containersButton">
          <div>
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                props.BtnClick == "edit"
                  ? updateSubSectorPage()
                  : addSubSectorsPage();
              }}
              disabled={false}
              title={props.BtnClick == "edit" ? "تعديل" : "اضافة"}
              text={props.BtnClick == "edit" ? "تعديل" : "اضافة"}
              show={true}
            />
          </div>
        </div>
      ) : (
        ""
      )}
      <LoaderAHSF
        show={
          state.SubSectors.loadingaI_SecondarySectors ||
          state.dropDownApplicationInformationLoding.loadingSubSector
        }
      />
    </div>
  );
};

export default AddEditeSubSectorsPage;
